var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.5)",
    d: "M9.548 1.696a.504.504 0 0 1 .903 0l2.392 4.845a.504.504 0 0 0 .379.276l5.346.777c.413.06.578.567.28.859l-3.87 3.77a.503.503 0 0 0-.144.446l.913 5.325a.504.504 0 0 1-.73.531l-4.783-2.514a.504.504 0 0 0-.468 0l-4.782 2.514a.504.504 0 0 1-.731-.53l.913-5.326a.504.504 0 0 0-.145-.445L1.153 8.453a.504.504 0 0 1 .279-.86l5.346-.776a.504.504 0 0 0 .38-.276l2.39-4.845Z"
  })));
};
export default SvgStar;